export default __webpack_public_path__ + "static/media/IndependenceNew1.3527b834.JPG";